module.exports = __webpack_public_path__ + "img/cloud1.7cb02651.png";